import * as React from "react";
import PortalInput from './PortalInput';
import styleable from "react-styleable";
import { t } from 'ttag';

import * as styles from '../../../css/components/mainlayout/portalselect.css';

/**
 * ## styleable
 * * **container** Styling for the container.
 * * **smallNote** Styling for the small note above the search field.
 * * **portalSelectItemSelected** Styling for the selected items.
 * * **portalSelectItem** Styling for all items.
 *
 *  * ## Background color settings css
 * ```
 * .portalSelectItemSelected, .portalSelectItemSelected:hover{
 *   background-color: green;
 * }
 *
 * @property {PortalSelectItem} props.children
 * @property {Object}   props.selectedId for single select
 * @property {[Object]} props.selectedIds for multiselect - required when using selectedItems
 * @property {[Object]} props.selectedItems for multiselect - required when using selectedIds
 * @property {int}      props.maxSelected for multiselect maximum number of selected items
 * @property {bool}     props.searchable to enable or disable search functionality, on by default
 * @property {function} props.onSelectionChange - On change event, the selected item's data value is passed on
 */
class PortalSelect extends React.Component<any, any> {

    constructor(){
        super(undefined); // TODO: undefined
        this.state = {
            selectedIds: [],
            selectedItems: [],
            filter: "",
        }
    }

    renderChildren(props) {
        let i = 0;
        let res = React.Children.map(props.children, (child: any) => {
            // if (child.type === PortalSelectItem)
                if(child.props.children !== undefined && child.props.children.toString().toLowerCase().includes(this.state.filter.toLowerCase())){
                    let generatedId = i++;
                    let currentId = child.props.id !== undefined ? child.props.id : generatedId;
                    let isSelected = this.supportsMultiselect() ? this.state.selectedIds.indexOf(currentId) >= 0 :
                                            this.state.selectedIds[0] === currentId;
                    return React.cloneElement(child, {
                        onSelectionChange: this.onSelectionChange.bind(this),
                        id: currentId,
                        selected: isSelected,
                        css: this.props.css,
                    });
                }else{
                    i++;
                    return null;
                }
            // else
            //     return child
        });
        if (res.length === 0){
            return <p className = {this.props.css.smallNote}>{t`Geen resultaten.`}</p>;
        }else{
            return res;
        }
    };

    supportsMultiselect(){
        return this.props.selectedIds !== undefined;
    }

    componentWillMount(){
        if(this.props.selectedId !== undefined){
            this.setState({
                selectedIds: [this.props.selectedId]
            });
        }else if(this.supportsMultiselect() && (
                this.props.maxSelected === undefined
            ||
                this.props.selectedIds.length <= this.props.maxSelected
        )){
            this.setState({
                selectedIds: [...this.props.selectedIds],
                selectedItems: [...this.props.selectedItems]
            })
        }
    }

    onSelectionChange(portalSelectItem){

        let selectedIds;
        let selectedItems;
        let useState = false;
        if(this.props.selectedIds === undefined && this.props.selectedId === undefined){
            selectedIds = this.state.selectedIds;
            selectedItems = this.state.selectedItems;
            useState = true;
        }else if(this.props.selectedId !== undefined){
            selectedIds = [this.props.selectedId]
        }else if(this.props.selectedIds !== undefined && this.props.selectedItems !== undefined){
            selectedIds = this.props.selectedIds;
            selectedItems = this.props.selectedItems;
        }

        let id = portalSelectItem.props.id === undefined ? (this.props.children as any).indexOf(portalSelectItem) : portalSelectItem.props.id;
        if(this.supportsMultiselect()){
            let newIds = [...selectedIds];
            let newItems = [...selectedItems];
            if(selectedIds.indexOf(id) >= 0){
                let currentIndexInList = selectedIds.indexOf(id);
                newIds.splice(currentIndexInList, 1);
                newItems.splice(currentIndexInList, 1);
            }else{
                if(this.props.maxSelected === undefined || newItems.length < this.props.maxSelected){
                    newIds.push(id);
                    newItems.push(portalSelectItem.props.data);
                }
            }
            if(useState)
                this.setState({
                    selectedIds: newIds,
                    selectedItems: newItems
                });
            if(this.props.onSelectionChange !== undefined)
                this.props.onSelectionChange(newItems);
        }else{
            if(useState)
                this.setState({
                    selectedIds : [id],
                });
            if(this.props.onSelectionChange !== undefined)
                this.props.onSelectionChange(portalSelectItem.props.data);
        }
    };

    onTextChange(inputValue){
        this.setState({filter: inputValue})
    }

    componentWillReceiveProps(nextProps) {
        if(this.supportsMultiselect()){
            this.setState({
                selectedIds: [...nextProps.selectedIds],
                selectedItems: [...nextProps.selectedItems]
            });
        }else if(nextProps.selectedId !== undefined){
            this.setState({
                selectedIds: [nextProps.selectedId],
                selectedItems: []
            });
        }else{
            this.setState({
                selectedIds: [],
                selectedItems: []
            });
        }
    }

    render() {
        let search = this.props.searchable === false ? "" : <PortalInput placeholder={this.props.placeholder} onChange={(v) => this.onTextChange(v)}/>;
        return (
        <div>
            {search}
            <div className = {this.props.css.container}>
                {/*Insert portal select items*/}
                {this.renderChildren(this.props)}
            </div>
        </div>
    );
    }
}

export default styleable(styles)(PortalSelect);